import { render, staticRenderFns } from "./DeployedDPDetailDialog.vue?vue&type=template&id=b65be9a2&scoped=true&"
import script from "./DeployedDPDetailDialog.vue?vue&type=script&lang=js&"
export * from "./DeployedDPDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeployedDPDetailDialog.vue?vue&type=style&index=0&id=b65be9a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65be9a2",
  null
  
)

export default component.exports